import AmioHttpService from './amio-http.service'

class ChatThemeService extends AmioHttpService {
  async create({ name = 'New theme', themeConfig = {}, langConfig = {} }) {
    const { data } = await this.requestPost('/chat-themes', {
      name,
      themeConfig,
      langConfig
    })

    return this._adaptData(data)
  }

  async list() {
    const { data } = await this.requestGet('/chat-themes')
    return data.map(this._adaptData)
  }

  async update({ id, themeConfig = {}, langConfig = {}, name }) {
    const { data } = await this.requestPatch(`/chat-themes/${id}`, {
      name,
      themeConfig,
      langConfig
    })

    return this._adaptData(data)
  }

  async delete(chatThemeId) {
    return this.requestDelete(`/chat-themes/${chatThemeId}`)
  }

  async get(chatThemeId) {
    const { data } = await this.requestGet(`/chat-themes/${chatThemeId}`)
    return this._adaptData(data)
  }

  // PRO-715: a PARTIAL theme ({themeConfig, langConfig}) derived from the website; nothing is saved
  async generateFromWebsite(website) {
    const { data } = await this.requestPost('/utils/site-identity', { website })
    return {
      themeConfig: data.theme_config || {},
      langConfig: data.lang_config || {}
    }
  }

  _adaptData(data) {
    return {
      id: data?.id,
      name: data.name,
      themeConfig: data.theme_config,
      langConfig: data.lang_config
    }
  }
}

export default new ChatThemeService()
